import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

// Global axios configuration  
axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const toBeSignedDocumentService = {
  createDocument,
  assignToReservation,
  getByReservation,
  getDocument,
  deleteDocument,
  downloadSignedDocument,
  downloadUnsignedDocument,
  downloadAutomatic,
  // Metodi per cittadino
  signDocumentAsCitizen,
  downloadDocumentPdfAsCitizen,
};

/**
 * Crea un nuovo documento firmabile
 * @param {string} documentTemplateHashid Hashid del template documento
 * @param {string} htmlContent Contenuto HTML del documento
 * @returns {Promise} Response con hashid del documento creato
 */
function createDocument(documentTemplateHashid, htmlContent) {
  return axios
    .post("tobesigneddocuments", { 
      document_template_hashid: documentTemplateHashid,
      html_content: htmlContent
    }, { headers: authHeader() })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}

/**
 * Assegna reservation_id ai documenti firmabili
 * @param {Array} documentHashids Array di hashid dei documenti
 * @param {string} reservationHashid Hashid della prenotazione
 * @returns {Promise} Response di conferma
 */
function assignToReservation(documentHashids, reservationHashid) {
  return axios
    .post("tobesigneddocuments/assign-to-reservation", { 
      document_hashids: documentHashids,
      reservation_hashid: reservationHashid
    }, { headers: authHeader() })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}

/**
 * Ottieni documenti firmabili per una prenotazione
 * @param {string} reservationHashid Hashid della prenotazione
 * @returns {Promise} Response con array di documenti
 */
function getByReservation(reservationHashid) {
  return axios
    .get(`tobesigneddocuments/reservation/${reservationHashid}`, { headers: authHeader() })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}

/**
 * Ottieni documento firmabile per hashid
 * @param {string} hashid Hashid del documento
 * @returns {Promise} Response con dati del documento
 */
function getDocument(hashid) {
  return axios
    .get(`tobesigneddocuments/${hashid}`, { headers: authHeader() })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}

/**
 * Elimina documento firmabile
 * @param {string} hashid Hashid del documento
 * @returns {Promise} Response di conferma
 */
function deleteDocument(hashid) {
  return axios
    .delete(`tobesigneddocuments/${hashid}`, { headers: authHeader() })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}

/**
 * Firma documento firmabile come cittadino
 * @param {string} hashid Hashid del documento
 * @returns {Promise} Response di conferma
 */
function signDocumentAsCitizen(hashid) {
  return axios
    .post(`tobesigneddocuments/${hashid}/sign`, {}, { headers: authHeader() })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}

/**
 * Scarica PDF del documento firmabile come cittadino
 * @param {string} hashid Hashid del documento
 * @returns {Promise} Response con il file PDF
 */
function downloadDocumentPdfAsCitizen(hashid) {
  return axios
    .get(`tobesigneddocuments/${hashid}/pdf`, { 
      headers: authHeader(),
      responseType: 'arraybuffer'  // PDF.js ha bisogno di arraybuffer
    })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}

/**
 * Scarica PDF del documento firmato (unificato per cittadino e operatore)
 * Il backend gestisce i controlli di autorizzazione basati su ruolo utente
 * @param {string} hashid Hashid del documento
 * @returns {Promise} Response con il file PDF
 */
function downloadSignedDocument(hashid) {
  return axios
    .get(`tobesigneddocuments/${hashid}/signed-pdf`, { 
      headers: authHeader(),
      responseType: 'blob'
    })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}

/**
 * Scarica PDF del documento da firmare (unificato per cittadini e operatori)
 * Il backend gestisce i controlli di autorizzazione basati su ruolo utente
 * @param {string} hashid Hashid del documento
 * @returns {Promise} Response con il file PDF
 */
function downloadUnsignedDocument(hashid) {
  return axios
    .get(`tobesigneddocuments/${hashid}/pdf`, { 
      headers: authHeader(),
      responseType: 'blob'
    })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}

/**
 * Download automatico del PDF corretto (firmato o non firmato) in base allo stato del documento
 * Il backend fa da router e decide quale PDF restituire
 * @param {string} hashid Hashid del documento
 * @returns {Promise} Response con il file PDF
 */
function downloadAutomatic(hashid) {
  return axios
    .get(`tobesigneddocuments/${hashid}/download`, { 
      headers: authHeader(),
      responseType: 'blob'
    })
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);  
    });
}